import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidator {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  static passwordMatchValidator(control: AbstractControl) {
    const password: string = control.get('newpassword')?.value;
    const confirmPassword: string = control.get('conformpassword')?.value;
    if (password !== confirmPassword) {
      control.get('conformpassword')?.setErrors({ NoPassswordMatch: true });
    }
  }

  static validateSsn(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const error: ValidationErrors = {};
      const data = control.value.split('');
      const val = data[0] + data[1] + data[2];
      function between(x, min, max) {
        return x >= min && x <= max;
      }
      if (val === '666' || val === '900' || val === '999') {
        error['firstgroup'] = true;
      }
      if (data.includes('0')) {
        error['hasZero'] = true;
      }
      const test = data[0] + data[1] + data[2] + data[4] + data[5] + data[7] + data[8] + data[9] + data[10];
      if (between(test, 987654320, 987654329)) {
        error['mediaSsn'] = true;
      }
      return error;
    };
  }

  static validateTelephone(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const error: ValidationErrors = {};
      const data = control.value.split('');
      if (data[0] === '0' || data[1] === '1' || data[0] === '1' || data[1] === '0') {
        error['hasZero'] = true;
      }
      return error;
    };
  }
}
